import React from "react";
import { Button, Col } from "react-bootstrap";

export default function ButtonWithIcon({
  variant,
  Icon,
  text,
  clickable,
  onClick,
}) {
  return (
    <Button
      className="w-100 d-flex align-items-center"
      variant={variant}
      onClick={onClick}
      style={{
        cursor: clickable ? "pointer" : "default",
        borderRadius: "0.5rem",
      }}
    >
      <Icon />
      <Col className="d-flex">
        <div className="text-start">{text}</div>
      </Col>
    </Button>
  );
}
